<div class="mb-4 flex items-center justify-between gap-4">
	<div class="text-base font-bold text-black">Pilot Data Management</div>
	<button (click)="uploadData()" class="aa-btn shrink-0" data-variant="primary" data-size="small">
		<span class="aa-mat-icon">add_box</span> Upload Data
	</button>
</div>

<div class="mb-4 w-full max-w-xs">
	<div class="relative">
		<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
			<input
				matInput
				[(ngModel)]="searchQuery"
				(input)="onSearch()"
				placeholder="Search by Staff ID/Name"
				class="pr-10"
			/>
			<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
		</mat-form-field>
		@if (searchQuery && searchQuery.trim().length > 0 && searchQuery.trim().length < 3) {
			<mat-hint class="text-xs text-amber-600"> Please enter at least 3 characters to search </mat-hint>
		}
	</div>
</div>

<!-- TABLE -->
<div class="cbta-tbl pilot-data-tbl">
	<div class="columns">
		<div class="column col-12">
			<ngx-table
				[configuration]="configuration"
				[data]="pilots"
				[noResultsTemplate]="noResultsTemplate"
				[columns]="columns"
				[pagination]="pagination"
				(event)="onTableChanged($event)"
			>
			</ngx-table>
		</div>

		<!-- TEMPLATE: Id -->
		<ng-template #idTpl let-row let-rowIndex="rowIndex">
			<span class="font-bold">{{ row.staffNumber }}</span>
		</ng-template>

		<!-- TEMPLATE: Name -->
		<ng-template #nameTpl let-row let-rowIndex="rowIndex">
			<span>{{ row.name }}</span>
		</ng-template>

		<!-- TEMPLATE: Date -->
		<ng-template #uploadedDateTpl let-row let-rowIndex="rowIndex">
			<span class="text-violet">{{ formatDate(row.lastUpdated) }}</span>
		</ng-template>

		<!-- TEMPLATE: Action Button with Menu -->
		<ng-template #actionTpl let-row let-rowIndex="rowIndex">
			<div class="flex items-center justify-center">
				<button
					class="mx-auto size-9 p-0 text-violet"
					[matMenuTriggerFor]="actionMenu"
					[matMenuTriggerData]="{ row, rowIndex }"
					(click)="selectRow(row)"
				>
					<mat-icon>more_vert</mat-icon>
				</button>
			</div>
		</ng-template>

		<!-- TEMPLATE: No Results -->
		<ng-template #noResultsTemplate>
			<td [attr.colspan]="columns.length" class="h-[180px] text-center">
				<span class="text-grey-40">No results found.</span>
			</td>
		</ng-template>
	</div>
</div>

<!-- MAT MENU (Global) -->
<mat-menu #actionMenu="matMenu" class="!min-w-36 border border-[#CFE3FF] px-1 !shadow-sm">
	<ng-template matMenuContent let-row="row" let-index="rowIndex">
		<button class="menu-btn" (click)="viewFolders(row.staffNumber)">
			<span>View Folder</span>
		</button>
		<button class="menu-btn hover:!bg-red" (click)="uploadFile(row.staffNumber)">
			<span>Upload File</span>
		</button>

		<!-- <button
			mat-menu-item
			class="block h-8 w-full rounded px-2 text-left !text-red transition-all duration-200 hover:bg-violet hover:text-white"
			(click)="removePilotData(row)"
		>
			<mat-icon style="color: red">delete</mat-icon>
			<span>Remove</span>
		</button> -->
	</ng-template>
</mat-menu>
